<template>
  <div class="top m_flex_box flex_vc flex_jz">
    <div class="logo-box m_flex_box flex_vc">
      <img src="@/assets/login/logo.png" class="logo" @click="refreshPage" />
      <template v-if="$store.state.isRole !=4 && $route.path !='/supertubeLogin'">
        <div class="language m_flex_box flex_vc" :style="language == 'zh'? 'width: 85px':'width: 100px'">
          <img src="@/assets/demandSide/中文.png" class="flag" v-if="language == 'zh'">
          <img src="@/assets/demandSide/国际区.png" class="flag" v-else>
          <el-select v-model="language" @change="changeLanguage">
            <el-option :label="$t('中文')" value="zh">
              <div class="m_flex_box flex_vc">
                <img src="@/assets/demandSide/中文.png" class="flag-icon">
                <div>{{$t('中文')}}</div>
              </div>
            </el-option>
            <el-option :label="$t('英文')" value="en">
              <div class="m_flex_box flex_vc">
                <img src="@/assets/demandSide/国际区.png" class="flag-icon">
                <div>{{$t('英文')}}</div>
              </div>
            </el-option>
          </el-select>
        </div>
        <div class="language m_flex_box flex_vc" :style="language == 'zh'? 'width: 100px':form.globalRegionsId == '1'?'width: 130px':'width: 180px'" v-if="$store.state.isRole !=3">
          <img src="@/assets/demandSide/中文.png" class="flag" v-if="form.globalRegionsId == '1'">
          <img src="@/assets/demandSide/国际区.png" class="flag" v-else>
          <el-select v-model="form.globalRegionsId" size="mini" @change="changeArea">
            <el-option :label="$t('中国区')" :value="'1'">
              <div class="m_flex_box flex_vc">
                <img src="@/assets/demandSide/中文.png" class="flag-icon">
                <div>{{$t('中国区')}}</div>
              </div>
            </el-option>
            <el-option :label="$t('国际区')" :value="'2'">
              <div class="m_flex_box flex_vc">
                <img src="@/assets/demandSide/国际区.png" class="flag-icon">
                <div>{{$t('国际区')}}</div>
              </div>
            </el-option>
          </el-select>
        </div>
      </template>
      <div v-else style="width:50px"></div>
    </div>
    <template v-if="allNav.indexOf(active) ==-1 && $store.state.role =='0'">
      <div class="language m_flex_box" style="width: 110px" v-if="$store.state.isRole == 3"></div>
      <el-input :placeholder="$t('搜索')" v-model="form.names" class="input-with-select flex-1" v-if="$store.state.isRole != 3 && searchNav.indexOf(active)>-1" clearable>
        <el-select v-model="form.select" slot="prepend" class="select">
          <template v-for="item in $store.state.isRole == 4? suplyRole:($store.state.isRole == 1 || $store.state.isRole == 0 ? typeList : supplyList)">
            <el-option :label="item.name" :value="item.id"></el-option>
          </template>
        </el-select>
        <el-button class="btn" slot="append" icon="el-icon-search" @click="searchMer()"></el-button>
      </el-input>
      <div class="input-with-select flex-1" v-else></div>
      <div class="m_flex_box flex_vc pointer" @click="publishNeeds()" v-if="$store.state.isRole == 1 || $store.state.isRole == 0">
        <i class="el-icon-circle-plus"></i>
        <div>{{$t("发布需求")}}</div>
      </div>
      <div class="language m_flex_box" style="width: 85px" v-else></div>
      <div class="login m_flex_box flex_vc" v-if="$store.state.isLoggedIn&&$store.state.userInfo && $store.state.isRole != 4">
        <el-dropdown trigger="click">
          <span class="el-dropdown-link pointer" style="font-size: 16px">
            {{ $store.state.userInfo.names || "" }}<i class="el-icon-arrow-down el-icon--right"></i>
          </span>
          <el-dropdown-menu slot="dropdown">
            <div class="userInfo">
              <div class="m_flex_box">
                <div style="margin-right: 10px">
                  <safe-image :src="$store.state.userInfo.headPic" alt="" class="img" style="width: 50px;height: 50px;border-radius: 50%" />
                </div>
                <div class="flex-1">
                  <div style="margin-top: 5px">{{ $store.state.userInfo.names || "" }}</div>
                  <div style="margin-top: 10px">ID: {{ $store.state.userInfo.numbers || "" }}</div>
                </div>
                <div class="m_flex_box flex_he">
                  <span class="goOut pointer" @click="logoutRole">{{$t('退出')}}</span>
                </div>
              </div>
              <div class="m_flex_box" style="margin-top: 20px">
                <div class="m_flex_box flex_vc">{{$t('切换身份')}}：</div>
                <el-select v-model="$store.state.isRole || '1'" :placeholder="$t('请选择')" class="flex-2" @change="changeIdentity">
                  <el-option :label="$t('需求方/招标/招聘')" value="1"></el-option>
                  <el-option :label="$t('供应方/投标/投聘')" value="2" v-if="$store.state.userInfo.roleId.includes(2) || roleId.includes(2)"></el-option>
                  <el-option :label="$t('协调方')" value="3" v-if="$store.state.userInfo.roleId.includes(3) || roleId.includes(3)"></el-option>
                </el-select>
              </div>
            </div>
          </el-dropdown-menu>
        </el-dropdown>
        <template v-if="$store.state.auditStatus == 3">
          <img src="@/assets/demandSide/未认证.png" alt="" class="img">
          <div class="underline pointer" @click="$router.push('/myAccount/myAuth')">{{$t("已拒绝")}}</div>
        </template>
        <template v-if="$store.state.auditStatus == 2">
          <img src="@/assets/demandSide/已认证.png" alt="" class="img">
          <div class="underline pointer" @click="$router.push('/myAccount/myAuth')">{{$t("已认证")}}</div>
        </template>
        <template v-if="$store.state.auditStatus == 1">
          <img src="@/assets/demandSide/未认证.png" alt="" class="img">
          <div class="underline pointer" @click="$router.push('/myAccount/myAuth')">{{$t("审核中")}}</div>
        </template>
        <template v-if="$store.state.auditStatus == 0">
          <img src="@/assets/demandSide/未认证.png" alt="" class="img">
          <div class="underline pointer" @click="$router.push('/becomeDemandSide')">{{$t("未认证")}}</div>
        </template>
<!--        <el-popover-->
<!--          width="200"-->
<!--          trigger="manual"-->
<!--          v-model="visible">-->
<!--          <p>{{ this.auditReason }}</p>-->
<!--          <div style="text-align: right; margin: 0">-->
<!--            <el-button class="btnSub" @click="visible = false">{{$t("继续")}}</el-button>-->
<!--          </div>-->
<!--        </el-popover>-->
      </div>
      <div class="login m_flex_box flex_vc"  v-else>
        <div class="login m_flex_box flex_vc" v-if="$store.state.isRole != 4">
          <div class="underline pointer" @click="$router.push('/login')">{{$t("登录")}}</div>
          <div class="or">{{$t("或")}}</div>
          <div class="underline pointer" @click="$router.push('/register')">{{$t("注册")}}</div>
        </div>
        <div class="login m_flex_box flex_vc" v-else>
          <div>
            {{ $store.state.userInfo.names || "" }}
          </div>
          <div class="or"></div>
          <div class="pointer" @click="logout">{{$t("退出")}}</div>
        </div>
      </div>
      <el-dropdown trigger="click" v-if="$store.state.isRole == 1">
      <span class="el-dropdown-link pointer" style="font-size: 16px">
        {{$t("我的订单统计")}}<i class="el-icon-arrow-down el-icon--right"></i>
      </span>

        <el-dropdown-menu slot="dropdown">
          <div class="sum">
            <div class="m_flex_box flex_jz">
              <div class="title">{{$t("订单状态统计")}}</div>
              <div class="more pointer" @click="orderSeeMore">{{$t("查看更多")}}</div>
            </div>
            <div class="info m_flex_box flex_hw">
              <div class="item" v-for="(item,index) in dynamicNumbers1" :key="index">
                <div>{{language == 'zh'? item.name : item.engName}}</div>
                <div class="num">{{item.count}}</div>
              </div>
            </div>
          </div>
        </el-dropdown-menu>
      </el-dropdown>
      <div style="width: 190px" v-if="$store.state.isRole == 0"></div>
      <el-dropdown trigger="click" v-if="$store.state.isRole == 2">
      <span class="el-dropdown-link pointer" style="font-size: 16px">
        {{$t("需求订单统计")}}<i class="el-icon-arrow-down el-icon--right"></i>
      </span>

        <el-dropdown-menu slot="dropdown">
          <div class="sum">
            <div class="m_flex_box flex_jz">
              <div class="title" style="font-size: 16px">{{$t("需求订单统计")}}</div>
              <div class="more pointer" @click="$router.push('/supplySide/myAccount/winningOrder')">{{$t("查看更多")}}</div>
            </div>
            <div class="info m_flex_box flex_hw">
              <div class="item" v-for="(item,index) in dynamicNumbers" :key="index">
                <div>{{language == 'zh'? item.name : item.engName}}</div>
                <div class="num">{{item.count}}</div>
              </div>
            </div>
          </div>
        </el-dropdown-menu>
      </el-dropdown>
      <el-dropdown trigger="click" @command="toPath" v-if="$store.state.isRole != 4">
      <span class="el-dropdown-link pointer" style="font-size: 16px">
        {{$t("我的账户")}}<i class="el-icon-arrow-down el-icon--right"></i>
      </span>
        <el-dropdown-menu slot="dropdown">
          <div class="myAccount" v-if="$store.state.isLoggedIn!=1">
            <el-button class="buy-now-btn m_flex_box flex_vc flex_hc" @click="$router.push('/login')">{{$t("立即登录")}}</el-button>
            <div class="register">{{$t("新客户")}}？
              <span style="color: #0066C0" @click="$router.push('/register')" class="pointer">{{$t("免费注册")}}</span>
            </div>
          </div>
          <template v-if="$store.state.isRole == 1 || $store.state.isRole == 0">
            <div v-for="item in myNav">
              <el-dropdown-item :command="item.path">{{item.name}}</el-dropdown-item>
            </div>
          </template>
          <template v-if="$store.state.isRole == 2">
            <div v-for="item in myNavSupply">
              <el-dropdown-item :command="item.path">{{item.name}}</el-dropdown-item>
            </div>
          </template>
          <template v-if="$store.state.isRole == 3">
            <div v-for="item in myNavCoor">
              <el-dropdown-item :command="item.path">{{item.name}}</el-dropdown-item>
            </div>
          </template>
        </el-dropdown-menu>
      </el-dropdown>
    </template>

  </div>
</template>

<script>
import { EventBus } from '@/utils/eventBus.js';
import { parseAuthJson } from '@/utils/authStorage';
import { isAuthenticated } from '@/utils/auth';
export default {

  data() {
    return {
      // visible: false,
      searchNav: ['/','/demandSide/merchandiseDetail','/demandSide/merchandise','/demandSide/caseDetail','/supplySide/demandCardDetail',],
      allNav:['/login','/becomeDemandSide','/becomeCoordinator','/becomeSupply','/supertubeLogin','/forget','/captcha','/register'],
      active:'/',
      options: [{
        value: '1',
        label: this.$t("需求方")
      }, {
        value: '2',
        label: this.$t("供应方")
      }, {
        value: '3',
        label: this.$t("协调方")
      }],
      typeList:[//下拉筛选分类
        {
          id:1,
          name:this.$t("商品")
        },
        {
          id:2,
          name:this.$t("供应商")
        },
        {
          id:3,
          name:this.$t("案例")
        }
      ],
      supplyList:[
        {
          id:4,
          name:this.$t("需求")
        },
      ],
      suplyRole: [
        {
          id:2,
          name: this.$t("供应方")
        }
      ],
      myNavCoor:[
        {
          path:'/coordinatorSide/ordersGoods',
          name:this.$t("货品订单"),
        },
        {
          path:'/coordinatorSide/myAccount/demandOrder',
          name:this.$t("需求订单"),
        },
        {
          path:'/myAccount/myAuth',
          name:this.$t("我的认证"),
        },
        {
          path:'/coordinatorSide/myAccount/accountSettings',
          name:this.$t("账户设置"),
        },
        {
          path:'/myAccount/myPerinfo',
          name:this.$t("个人资料"),
        },
        {
          path:'/myAccount/messages',
          name:this.$t("我的消息"),
        }
      ],
      myNav:[
        {
          path:'/myAccount/myShopping',
          name:this.$t("我的购物"),
        },
        {
          path:'/myAccount/myNeeds',
          name:this.$t("我的需求"),
        },
        {
          path:'/myAccount/myPerinfo',
          name:this.$t("个人资料"),
        },
        {
          path:'/myAccount/myAuth',
          name:this.$t("我的认证"),
        },
        {
          path:'/captcha',
          name:this.$t("修改密码"),
        },
        {
          path:'/myAccount/messages',
          name:this.$t("我的消息"),
        }
      ],
      myNavSupply:[
        {
          path:'/supplySide/myAccount/myBidding',
          name:this.$t("我的投标"),
        },
        {
          path:'/supplySide/myAccount/winningOrder',
          name:this.$t("中标订单"),
        },
        {
          path:'/supplySide/myAccount/myShop',
          name:this.$t("我的店铺"),
        },
        {
          path:'/supplySide/myShop/merchandiseManage',
          name:this.$t("商品管理"),
        },
        {
          path:'/supplySide/myAccount/orderManagement',
          name:this.$t("订单管理"),
        },
        {
          path:'/myAccount/myAuth',
          name:this.$t("我的认证"),
        },
        {
          path:'/supplySide/myAccount/caseManagement',
          name:this.$t("我的案例"),
        },
        {
          path:'/myAccount/myPerinfo',
          name:this.$t("个人资料"),
        },
        {
          path:'/myAccount/messages',
          name:this.$t("我的消息"),
        }
      ],
      language: this.$i18n.locale,
      userInfo: parseAuthJson('userInfo'),
      form:{
        globalRegionsId: this.$store.state.area, //中国区还是国际区
        select: this.$store.state.isRole==4? 2 : (this.$store.state.isRole==2? 4 : 1),//默认选中分类
        selectType: 0,
        names: ''
      },
      value: '',
      // auditReason:'',
      dynamicNumbers: [],
      dynamicNumbers1: [],
      roleId: ""
    }
  },
  watch:{
    '$route': function (to,from) {
      if(to.path == '/login') {
        this.roleId = "";
      }
      this.form.select = this.$store.state.isRole==4? 2 : (this.$store.state.isRole==2? 4 : 1);
      this.active = this.$route.path;
      if(this.$store.state.isRole==1) {
        this.queryAllGoodsOrdersStatesTotal();
      } else if (this.$store.state.isRole==2) {
        this.queryAllUsersDemandsStatesTotal();
      }
    },
    '$route.query.isRole': function(val){
      this.form.select = this.$store.state.isRole==4? 2 : (this.$store.state.isRole==2? 4 : 1);
      if(val==4) {
        this.$nextTick(() => {
          this.form.selectType = 2;
          EventBus.$emit('searchMerchandise', this.form);  // 触发事件
        });
      }
    },
  },
  created() {
    this.active = this.$route.path;
    this.form.select = this.$store.state.isRole==4? 2 : (this.$store.state.isRole==2? 4 : 1);
  },
  mounted() {
    this.form.select = this.$store.state.isRole==4? 2 : (this.$store.state.isRole==2? 4 : 1);
    const loggedIn = this.$store.state.isLoggedIn == 1 && isAuthenticated();
    if(loggedIn && this.$store.state.isRole != 4) {
      if(this.$store.state.isRole!=0) {
        this.queryUsersAuth(this.$store.state.isRole);
      }
    } else if(this.$store.state.isRole == 4) {
      this.form.selectType = 2;
      EventBus.$emit('searchMerchandise', this.form);  // 触发事件
    }
    if(loggedIn && this.$store.state.isRole==1) {
      this.queryAllGoodsOrdersStatesTotal();
    } else if (loggedIn && this.$store.state.isRole==2) {
      this.queryAllUsersDemandsStatesTotal();
    }
    if (loggedIn && this.$store.state.isRole !=0 && this.$store.state.isRole !=4) {
      this.$store.dispatch('attachmentDownload');
    }
  },
  methods: {
    queryAllUsersDemandsStatesTotal() {
      let data = {
        supplierBidId: this.$store.state.userInfo.id
      }
      this.$http({
        url: 'users/demandersDemandsApi/queryAllUsersDemandsStatesTotal',
        method: 'POST',
        data: this.$form(data)
      }).then((res) => {
        this.dynamicNumbers = res.data;
      })
    },
    queryAllGoodsOrdersStatesTotal() {
      let data = {
        usersId: this.$store.state.userInfo.id
      }
      this.$http({
        url: 'users/goodOrdersApi/queryAllGoodsOrdersStatesTotal',
        method: 'POST',
        data: this.$form(data)
      }).then((res) => {
        this.dynamicNumbers1 = res.data;
      })
    },
    changeIdentity(roleId) {
      this.form.select = roleId==2? 4 : 1;
      this.$store.commit('changeIsRole', roleId);
      this.queryUsersAuth(roleId);
      this.refreshPage();
    },
    // 查询我的认证信息
    queryUsersAuth(roleId) {
      let data = {
        roleId: roleId
      }
      this.$http({
        url: 'users/personalCenterApi/queryUsersAuth',
        method: 'POST',
        data:this.$form(data)
      }).then((res) => {
        if (res.state==10331) {
          this.$store.commit('changeAuditStatus', 0);
        } else {
          let auditStatus = res.data.auditStatus;
          // this.auditReason = res.data.auditReason;
          // if(this.auditReason) {
          //   this.visible = true;
          // }
          this.$store.commit('changeAuditStatus', auditStatus);
        }
        this.queryLoginUsersDetail(roleId)
      }).catch(error => {
        console.log(error,"error");
        this.loading = false;
        this.$store.commit('changeAuditStatus', '0');
      });
    },
    queryLoginUsersDetail(role) {
      let data = {}
      this.$http({
        url: 'users/personalCenterApi/queryLoginUsersDetail',
        method: 'POST',
        data: this.$form(data)
      }).then((res) => {
        this.roleId = res.data.roleId;
        let roleId = res.data.roleId;
        const containsOne = roleId.includes(role);
        if(containsOne){
          this.$store.commit('setQualification', 1);
        } else {
          this.$store.commit('setQualification', 0);
        }
      }).catch(error => {
        console.log(error)
      });
    },
    orderSeeMore(){
      if(this.$store.state.isLoggedIn) {
        this.$router.push('/myAccount/myShopping')
      } else {
        this.$router.push('/login')
      }
    },
    publishNeeds(){
      if(this.$store.state.isLoggedIn == 1) {
        if(this.$store.state.qualification == 1) {
          this.$router.push('/myAccount/myNeeds/publishNeeds')
        } else {
          if (this.$store.state.auditStatus == 1 || this.$store.state.auditStatus == 3) {
            this.$router.push('/myAccount/myAuth');
          } else if(this.$store.state.auditStatus == 2){
            this.$router.push('/myAccount/myNeeds/publishNeeds')
          } else {
            this.$router.push('/becomeDemandSide')
          }
        }
      } else {
        this.$router.push('/login')
      }
    },
    changeArea(val) {
      sessionStorage.setItem('area', val);
      this.$store.commit('changeArea', val);
      this.form.selectType = 0;
      EventBus.$emit('changeAreaOrLang', this.form);
      this.refreshPage('1');
    },
    refreshPage(val) {
      if(this.$route.path == '/login' && val ==1)  {
        this.$router.push('/login');
        window.location.reload();
      } else {
        if(this.$route.query.isLoggedIn==0) {
          this.$router.push('/login');
        } else {
          if (this.$route.path !== '/') {
            this.$router.push('/');
            setTimeout(() => {
              window.location.reload();
            }, 100);
          } else {
            window.location.reload();
          }
        }
      }
    },
    logoutRole() {
      this.form.select = 1;
      this.$router.push('/');
      this.$store.commit('logout');//   退出登录
    },
    logout() {
      this.$router.push('/login');
      this.$store.commit('logout');//   退出登录
    },
    //切换语言
    changeLanguage () {
      this.$i18n.locale = this.language;
      sessionStorage.setItem("theLanguage",this.language);
      EventBus.$emit('changeAreaOrLang', this.form);
      window.location.reload();
    },
    toPath(path){
      if(this.$store.state.isRole == 1 || this.$store.state.isRole == 0) {
        if (this.$store.state.isRole == 1) {
          if (path == '/myAccount/myShopping' || path == '/captcha' || path == '/myAccount/myPerinfo' || path == '/myAccount/messages') {
            this.$router.push(path);
          } else if (path == '/myAccount/myAuth') {
            if (this.$store.state.auditStatus == 0) {
              this.$router.push("/becomeDemandSide");
            } else if (this.$store.state.auditStatus == 2) {
              this.$router.push(path);
            } else if (this.$store.state.auditStatus == 1 || this.$store.state.auditStatus == 3) {
              this.$router.push(path);
            } else {
              this.$router.push("/becomeDemandSide");
            }
          } else if (path == '/myAccount/myNeeds') {
            if (this.$store.state.qualification == 0) {
              if (this.$store.state.auditStatus == 1 || this.$store.state.auditStatus == 3) {
                this.$router.push('/myAccount/myAuth');
              } else if(this.$store.state.auditStatus == 2){
                this.$router.push('/myAccount/myNeeds/publishNeeds')
              } else {
                this.$router.push('/becomeDemandSide')
              }
            } else {
              this.$router.push(path);
            }
          }
        } else {
          this.$router.push('/login');
        }
      } else {
        this.$router.push(path);
      }
    },
    searchMer() {
      if (this.$route.path!='/') {
        this.$router.push('/').then(() => {
          this.$nextTick(() => {
            this.form.selectType = this.form.select;
            EventBus.$emit('searchMerchandise', this.form);  // 触发事件
          });
        });
      }else {
        this.form.selectType = this.form.select;
        EventBus.$emit('searchMerchandise', this.form);  // 触发事件
      }
    }
  }
}
</script>

<style scoped lang="scss">
/deep/ {
  .el-popover {
    position: absolute;  /* 使 popover 定位到按钮的相对位置 */
    top: 60px;
    right: 150px;
    z-index: 1000; /* 确保 popover 显示在按钮下面 */
  }
}
.myAccount{
  width: 200px;
  .register{
    color: #3D2C02;
    text-align: center;
    font-size: 12px;
    margin: 10px 0;
  }
  .buy-now-btn {
    margin: 0 20px;
    height: 24px;
    background: #FFD814;
    border-radius: 3px;
    width: calc(100% - 40px);
    border-color: #FFD814;
    font-size: 12px;
    color: #281504;
  }
}
.flag-icon {
  width: auto;
  height: 12px;
  margin-right: 8px;
}
.userInfo {
  padding: 10px 15px;
  min-width: 420px;
  .goOut{
    color: #01698B;
  }
}
.sum{
  width: 450px;
  padding: 10px 15px;
  .title{
    font-size: 16px;
    font-weight: bold;
  }
  .more{
    text-decoration:underline;
  }
  .info{
    .item{
      width: 25%;
      margin-top: 15px;
      text-align: center;
      font-size: 14px;
      .num{
        font-weight: bold;
        margin-top: 10px;
        font-size: 16px;
      }
    }
  }
}
.top {
  height: 60px;
  background-color: #131921;
  color: #fff;
  padding: 0 1%;
  .logo-box{
    margin-right: 2%;
    .logo {
      width: 150px;
      //height: 40px;
      margin-right: 10px;
    }
    .web-name{
      font-size: 18px;
      .tip{
        font-size: 12px;
        margin-top: 5px;
      }
    }
  }

  .language {
    /deep/ {
      .el-input__inner {
        background-color: transparent;
        border: none;
        color: #fff;
        padding: 0;
        font-size: 16px;
      }
    }

    .flag {
      width: auto;
      height: 12px;
      margin-right: 6px;
      //margin-top: 5px;
    }
  }

  .input-with-select {
    max-width: 45%;
    margin: 0 15px;
    /deep/ {
      .el-input__inner:focus {
        border-color: transparent;
      }
    }

    .btn {
      background-color: #FEBD69;
      color: #ad6202;
    }

    .select {
      width: 108px;

      /deep/ {
        .el-input__inner {
          background-color: #e6e6e6;
          text-align: center;
        }
      }
    }
  }
  .login{
    margin-left: 5px;
    .underline{
      text-decoration:underline;
    }
    .or{
      margin: 0 8px;
    }
    .img {
      margin: 0 8px;
    }
  }
  .el-icon-circle-plus{
    margin-right: 5px;
  }
  .el-dropdown-link{
    margin: 0 5px;
    color: #fff;
  }

}
</style>



// WEBPACK FOOTER //
// src/views/layout/components/Top.vue